import { render, staticRenderFns } from "./BoxChart.vue?vue&type=template&id=85623368&scoped=true&lang=pug"
import script from "./BoxChart.vue?vue&type=script&lang=js"
export * from "./BoxChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85623368",
  null
  
)

export default component.exports